import { render, staticRenderFns } from "./deanInputFile.vue?vue&type=template&id=8e0a22be&scoped=true"
import script from "./deanInputFile.vue?vue&type=script&lang=ts"
export * from "./deanInputFile.vue?vue&type=script&lang=ts"
import style0 from "./deanInputFile.vue?vue&type=style&index=0&id=8e0a22be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0a22be",
  null
  
)

export default component.exports